import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputSelectField from '../../Fields/InputSelectField';
import InputTextField from '../../Fields/InputTextField';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import SurveyQuestionTable from '../../Fields/SurveyQuestionTable';
import ValidationProductTable from '../../Fields/ValidationProductTable';

import SurveyQuestion from '../../../Entities/SurveyQuestion';

class SettingsGeneralPanel extends React.Component {
  _onInputChange(inputId) {
    return value => {
      // console.trace()
      console.log('_onInputChange', {inputId, value})
      switch(inputId) {
        case 'use_ach':
          if (value !== null) value = (value === 'true') ? true : false;
          break;
        case 'display_organization_invoice_notes':
          if (value !== null) value = (value === 'true') ? true : false;
          break;
        default:
      }
  
      this.props.onValueChange(inputId, value);
    };
  }

  _onSurveyQuestionChange(type) {
    return (ident, value) => {
      const surveyQuestions = _.cloneDeep(this.props.settings.fields.survey_questions);

      // Define ident for new survey questions being added
      if (ident === null) ident = surveyQuestions[type].value.length;

      if (value === null) {
        // Removing survey question
        surveyQuestions[type].value.splice(ident, 1);
      }
      else {
        surveyQuestions[type].value[ident] = value;
      }

      this._onInputChange('survey_questions')(surveyQuestions);
    };
  }

  _onValidationProductChange() {
    return (ident, value) => {
      const validationProducts = _.cloneDeep(this.props.settings.fields.validation_products);

      if (ident === null) ident = validationProducts.value.length;

      if (value === null) {
        validationProducts.value.splice(ident, 1);
      } else {
        validationProducts.value[ident] = value;
      }

      this._onInputChange('validation_products')(validationProducts);
    }
  }

  handleAddPurchaseSurveyQuestionClick = () => {
    this._onSurveyQuestionChange('purchase')(null, new SurveyQuestion('PURCHASE'));
  }

  render() {
    const {
      editMode,
      settings,
      facility,
      fieldConfiguration,
      organizationInvoiceNotes,
    } = this.props;

    const {
      facilitySettings: facilitySettingsFieldConfiguration
    } = fieldConfiguration;

    const requiredFieldState = editMode;
    const dontShowInvioceNotes = !settings.fields.display_organization_invoice_notes.value;
    const organizationInvoiceNotesInputClassName = dontShowInvioceNotes ?
      "parkchirp--settings--invoice-notes-disabled" :
      "parkchirp--settings--invoice-notes-enabled";

    const purchaseSurveyQuestionsTableRows = settings.fields.survey_questions.purchase.value.map((surveyQuestion, index) => {
      return { ident: index, data: surveyQuestion };
    });

    return (
      <>
        <FieldGroup>
          <Field label="Facility Name"
            layout="columns">
            <span>{facility.fields.facility_name.value}</span>
          </Field>
          <Field label="Parking Period"
            id="parkchirp--settings--parking-period"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--settings--parking-period"
              value={settings.fields.parking_period.value}
              options={facilitySettingsFieldConfiguration.parking_period.options}
              onChange={this._onInputChange('parking_period')}
              editMode={editMode}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Online">
          <Field label="Display Online"
            id="parkchirp--settings--display"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--settings--display"
              value={settings.fields.display.value}
              options={facilitySettingsFieldConfiguration.display.options}
              onChange={this._onInputChange('display')}
              editMode={editMode}
            />
          </Field>
          <Field label="Make Model &amp; License Plate"
            id="parkchirp--settings--require-car-info"
            required={requiredFieldState}
            layout="columns">
            <InputSelectField inputId="parkchirp--settings--require-car-info"
              value={settings.fields.require_car_info.value}
              options={facilitySettingsFieldConfiguration.require_car_info.options}
              onChange={this._onInputChange('require_car_info')}
              editMode={editMode}
            />
          </Field>
          <Field label="ACH Payments"
            id="parkchirp--settings--ach-payments"
            required={requiredFieldState}
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--settings--ach-payments"
              value={settings.fields.use_ach.value}
              options={facilitySettingsFieldConfiguration.use_ach.options}
              onChange={this._onInputChange('use_ach')}
              editMode={editMode}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Invoice Notes">
          <Field label="Facility Invoice Notes">
            <InputTextField inputId="parkchirp--settings--invoice-notes"
              value={settings.fields.invoice_notes.value}
              onChange={this._onInputChange('invoice_notes')}
              editMode={editMode}
              multiLine={true}
            />
          </Field>
          <Field label="Organization Invoice Notes">
            <InputTextField inputId={organizationInvoiceNotesInputClassName}
              value={organizationInvoiceNotes}
              // onChange={this._onInputChange('organization_invoice_notes')}
              disabledMode={true}
              editMode={editMode}
              multiLine={true}
            />
          </Field>
          <Field label="Display Organization Notes on Invoice"
            id="parkchirp--settings--show-invoice-notes"
            required={requiredFieldState}
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--settings--show-invoice-notes"
              value={settings.fields.display_organization_invoice_notes.value}
              options={facilitySettingsFieldConfiguration.display_organization_invoice_notes.options}
              onChange={this._onInputChange('display_organization_invoice_notes')}
              editMode={editMode}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Survey">
          <Field>
            <SurveyQuestionTable inputId="parkchirp--settings--purchase-survey-questions"
              surveyQuestionRows={purchaseSurveyQuestionsTableRows}
              onSurveyQuestionChange={this._onSurveyQuestionChange('purchase')}
              editMode={editMode}
            />
            {(editMode) &&
              <div className="parkchirp--settings-general-panel--purchase-survey-questions--action-container">
                <button type="button"
                  className="parkchirp--button-as-link"
                  onClick={this.handleAddPurchaseSurveyQuestionClick}>
                  Add Survey Question
                </button>
              </div>
            }
          </Field>
        </FieldGroup>
        <FieldGroup label="Validation Products">
          <Field>
            <ValidationProductTable
              inputId="parkchirp--settings-general-panel--validation-product"
              validationProducts={settings.fields.validation_products.value}
              editMode={editMode}
              onValidationProductChange={this._onValidationProductChange()} />
          </Field>
        </FieldGroup>
      </>
    );
  }
}
export default SettingsGeneralPanel;
